import React, { useEffect, useRef } from 'react';

const BASE = 'https://menu.searchisend.in';

const AdBanner = ({ ad, restaurantId, fingerprint }) => {
    const impressionTracked = useRef(false);

    const trackEvent = React.useCallback(async (eventType) => {
        try {
            const fd = new FormData();
            fd.append('action', 'track_event');
            fd.append('ad_id', ad?.id);
            fd.append('restaurant_id', restaurantId);
            fd.append('event_type', eventType);
            fd.append('fingerprint', fingerprint || 'anonymous');

            await fetch(`${BASE}/apimenu/v2/v2_public_ads.php`, {
                method: 'POST',
                body: fd
            });
        } catch (err) {
            console.error('Tracking failed', err);
        }
    }, [ad, restaurantId, fingerprint]);

    useEffect(() => {
        if (ad && restaurantId && !impressionTracked.current) {
            trackEvent('Impression');
            impressionTracked.current = true;
        }
    }, [ad, restaurantId, trackEvent]);

    const handleClick = () => {
        trackEvent('Click');
        window.open(ad.target_url, '_blank', 'noopener,noreferrer');
    };

    if (!ad) return null;

    return (
        <div 
            onClick={handleClick}
            style={{
                width: '100%',
                margin: '20px 0',
                cursor: 'pointer',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: 'var(--card-bg-color, #fff)',
                border: '1px solid var(--border-color, #eee)'
            }}
        >
            <div style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                backgroundColor: 'rgba(0,0,0,0.6)',
                color: 'white',
                fontSize: '10px',
                padding: '3px 8px',
                borderRadius: '4px',
                pointerEvents: 'none',
                zIndex: 2,
                fontWeight: 'bold'
            }}>Sponsored</div>
            
            <div style={{ width: '100%', backgroundColor: '#f8f9fa', display: 'flex', justifyContent: 'center' }}>
                <img 
                    src={ad.image_url} 
                    alt={ad.title} 
                    style={{
                        width: '100%',
                        maxHeight: '200px',
                        display: 'block',
                        objectFit: 'contain'
                    }} 
                />
            </div>
            
            <div style={{
                padding: '12px 15px',
                color: 'var(--text-color, #333)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderTop: '1px solid #eee'
            }}>
                <strong style={{ fontSize: '15px', margin: 0, padding: 0 }}>{ad.title}</strong>
                <span style={{ color: 'var(--primary-color, #ea580c)', fontSize: '13px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '5px' }}>
                    Learn More <i className="fas fa-arrow-right"></i>
                </span>
            </div>
        </div>
    );
};

export default AdBanner;
